import { PortalReferralCreditNotAppliedReason } from '@app/services/api/api.types';

export type ReferralCreditNotAppliedCopy = {
  title: string;
  body: string;
};

const notAppliedCopy: Record<PortalReferralCreditNotAppliedReason, ReferralCreditNotAppliedCopy> = {
  [PortalReferralCreditNotAppliedReason.REQUIREMENTS_NOT_MET]: {
    title: 'Your $200 referral credit wasn’t applied',
    body: 'Your booking doesn’t meet the referral offer requirements, so the credit couldn’t be applied. Your travel expert can help explain the details.',
  },
  [PortalReferralCreditNotAppliedReason.NOT_A_NEW_CUSTOMER]: {
    title: 'Your $200 referral credit wasn’t applied',
    body: 'Not a new customer. The referral offer is available to new BCC customers only.',
  },
  [PortalReferralCreditNotAppliedReason.BOOKING_DEADLINE_PASSED]: {
    title: 'Your $200 referral credit wasn’t applied',
    body: 'Booking deadline passed. Your referral credit has expired because the booking wasn’t completed within the 3-month period.',
  },
  [PortalReferralCreditNotAppliedReason.REFEREE_NOT_TRAVELLING]: {
    title: 'Your $200 referral credit wasn’t applied',
    body: 'We couldn’t verify you as a traveler on this booking, so the referral credit couldn’t be applied. Your travel expert can help.',
  },
};

export function referralCreditNotAppliedCopy(
  reason?: PortalReferralCreditNotAppliedReason | null,
): ReferralCreditNotAppliedCopy {
  if (!reason) {
    return {
      title: 'Your $200 referral credit wasn’t applied',
      body: 'Your booking doesn’t meet the referral offer requirements, so the credit couldn’t be applied. Your travel expert can help explain the details.',
    };
  }

  return (
    notAppliedCopy[reason] ??
    notAppliedCopy[PortalReferralCreditNotAppliedReason.REQUIREMENTS_NOT_MET]
  );
}

/** @deprecated use referralCreditNotAppliedCopy */
export function referralCreditNotAppliedMessage(
  reason?: PortalReferralCreditNotAppliedReason | null,
) {
  return referralCreditNotAppliedCopy(reason).body;
}
